import { MRT_ColumnDef } from "material-react-table";
import type { Job } from "../../../../api/types";
import { ColumnContext, textColumn } from "./standard-column-types";

export function column_ExternalFarmId(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "externalFarmId", "externalFarmId");
}

export function column_LabName(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "importLabName", "labName");
}

export function column_ExternalLabId(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "externalLabId", "externalLabId");
}

export function column_ExternalId(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "externalId", "externalId");
}

export function column_YieldGoal(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "yieldGoal", "yieldGoal");
}

export function column_EventId(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "eventId", "eventId");
}

export function column_SubmitterName(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "submitterName", "submitterName");
}

export function column_SubmitterEmail(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "submitterEmail", "submitterEmail", {
		inputType: "email",
	});
}

export function column_FieldId(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "fieldId", "fieldId", { hasGroupUpdate: false });
}

export function column_SubmissionNotes(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "submissionNotes", "submissionNotes");
}

export function column_GrowerPhone(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "growerPhoneNumber", "growerPhoneNumber", {
		inputType: "tel",
	});
}

export function column_LabInstructions(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "labInstructions", "labInstructions");
}

export function column_LabSubmissionCode(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "labSubmissionCode", "labSubmissionCode");
}

export function column_Grower(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "importGrowerName", "grower");
}

export function column_Farm(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "importFarmName", "farm", { hasGroupUpdate: false });
}

export function column_Field(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "importFieldName", "field", { hasGroupUpdate: false });
}

export function column_MicrosList(context: ColumnContext): MRT_ColumnDef<Job, unknown> {
	return textColumn(context, "microsList", "microsList", {
		isDisabled: (row) => {
			const job = row.original;
			return !job?.files.pointsSHP || job.files.pointsSHP.length === 0;
		},
	});
}
